import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import React, {useState, useEffect} from "react";
import DatePicker from "react-datepicker";
import {LlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";
import formatDateToLocalISOString from "routes/llm_run/utils/format_date_local_iso_string";

interface DateFilterProps {
  values: LlmRunQueryParams;
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, string | number>>,
  ) => void;
}

export default function DateFilter({values, updateValue}: DateFilterProps) {
  const [dates, setDates] = useState({
    from: values.from ? new Date(values.from) : null,
    to: values.to ? new Date(values.to) : null,
  });

  useEffect(() => {
    setDates({
      from: values.from ? new Date(values.from) : null,
      to: values.to ? new Date(values.to) : null,
    });
  }, [values.from, values.to]);

  const handleDateChange = (field: "from" | "to", date: Date | null) => {
    if (field === "to" && date) {
      if (!dates.to) {
        date.setHours(23, 59, 59);
      } else {
        date.setHours(date.getHours(), date.getMinutes(), date.getSeconds());
      }
    }
    setDates(prevDates => ({...prevDates, [field]: date}));
  };

  const handleDateBlur = (field: "from" | "to") => {
    const date = dates[field];
    if (date) {
      // Format the date in local time, but as ISO string without timezone info
      const formattedDate = formatDateToLocalISOString(date);
      updateValue({[field]: formattedDate});
    } else {
      updateValue({[field]: null});
    }
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "1em",
        zIndex: 10,
      }}
    >
      <DatePicker
        selected={dates.from}
        onChange={date => handleDateChange("from", date)}
        onCalendarClose={() => handleDateBlur("from")}
        onBlur={() => handleDateBlur("from")}
        timeInputLabel="Time:"
        dateFormat="dd/MM/yyyy HH:mm"
        showTimeInput
        placeholderText="Select start date"
        timeFormat="HH:mm"
        maxDate={dates.to}
      />
      <DatePicker
        selected={dates.to}
        onChange={date => handleDateChange("to", date)}
        onCalendarClose={() => handleDateBlur("to")}
        onBlur={() => handleDateBlur("to")}
        timeInputLabel="Time:"
        dateFormat="dd/MM/yyyy HH:mm"
        showTimeInput
        isClearable
        placeholderText="Select end date"
        timeFormat="HH:mm"
        minDate={dates.from}
      />
    </div>
  );
}
